import React, { useMemo } from 'react';
import { useGetAvatarQuery } from '../api/productionsApi';
import { Production } from '../types';
import { useApiQuery } from '@common/hooks';
import { SkipOrArgs } from '@common/types/queryState';
import { skipToken } from '@reduxjs/toolkit/query';

export const useProductionAvatar = (production: Production) => {
    const queryArgs: SkipOrArgs<{ productionId: string }> = useMemo(() => {
        if (!production || !production.hasAvatar) return skipToken;
        return { productionId: production.id };
    }, [production]);

    const { data: avatar, ...queryResult } = useApiQuery(
        useGetAvatarQuery,
        queryArgs,
    );

    React.useEffect(() => {
        return () => {
            if (avatar) {
                URL.revokeObjectURL(avatar);
            }
        };
    }, [avatar]);

    return {
        avatar,
        ...queryResult,
    };
};
